<template>
    <div>
        <LoadingWheel :width="100" v-show="loading" class="page-loading body-loading" />
        <div class="container tile" v-show="!loading">
            <div class="text-right pull-right-sm" style="margin-top: 10px">
                <a class="btn btn-outline-secondary" @click.prevent="$emit('change-page', { page: 'Admin' })" :href="adminUrl">Admin Menu</a>
            </div>
            <h1>Address Book</h1>
            <p>
                There are currently <strong id="groupCount">{{ groupCount }}</strong> groups in your address book.
            </p>

            <hr />
            <div v-show="canEdit">
                <button type="button" class="btn btn-outline-secondary" @click="addGroup">
                    <span class="plus-sign">+</span>
                    <span class="sr-only">Add</span>
                    New Group
                </button>
            </div>
            <br v-show="canEdit" />
            <div class="accordion" id="addressBookAccordion" role="tablist" aria-multiselectable="false">
                <div class="card" v-for="(group, groupIndex) in groups">
                    <a :href="'#group' + groupIndex" role="button" data-toggle="collapse" data-parent="#addressBookAccordion" class="card-header collapsed" aria-expanded="false" @click.prevent="openGroup(group)">
                        <div class="panel-heading">
                            <div class="pull-right group_totals">
                                <span class="group_individuals_total" v-show="group.individuals.length > 0">
                                    <img src="./ico_individual.png" alt="" title="Number of individuals in this group" />
                                    <span class="sr-only">Number of individuals in this group:</span>
                                    <span class="total_number">{{ group.individuals.length }}</span>
                                </span>
                                <br class="d-block d-md-none" />
                                <span class="group_groups_total" v-show="group.groups.length > 0">
                                    <img src="./ico_group.png" alt="" title="Number of groups in this group" />
                                    <span class="sr-only">Number of groups in this group:</span>
                                    <span class="total_number">{{ group.groups.length }}</span>
                                </span>
                            </div>
                            <strong class="panel_heading_group_name">{{ group.displayName }}<span v-show="!group.displayName" style="color: #999999">&lt;Unnamed Group&gt;</span></strong>
                        </div>
                    </a>

                    <div class="panel-collapse" :class="groupMetadata(groupIndex).open ? [] : ['collapse']" :id="'group' + groupIndex" role="tabpanel" aria-expanded="false">
                        <div class="card-body">
                            <div v-if="canEdit">
                                <div class="text-right">
                                    <span v-show="!groupMetadata(groupIndex).editing">
                                        <a id="launchBtn" class="btn btn-primary" @click="groupMetadata(groupIndex).editing = true" role="button" tabindex="0">
                                            Edit
                                            <span v-show="groupMetadata(groupIndex).saveStatus == 'ok'" class="icon icon-check"></span>
                                        </a>
                                    </span>
                                    <span v-show="groupMetadata(groupIndex).editing">
                                        <a id="launchBtn" class="btn btn-primary" @click="saveGroup(group, groupIndex)" role="button" tabindex="0">
                                            <span class="icon icon-save"></span>
                                            Save
                                            <span v-show="groupMetadata(groupIndex).saveStatus == 'ok'" class="icon icon-check"></span>
                                            <span v-show="groupMetadata(groupIndex).saveStatus == 'fail'" class="icon icon-attention"></span>
                                            <LoadingWheel :width="16" v-show="groupMetadata(groupIndex).saveStatus == 'in-progress'" style="position: relative; top: -2px" />
                                        </a>
                                    </span>
                                    <a class="btn btn-outline-secondary" @click="removeGroup(group, groupIndex)" role="button" tabindex="0">
                                        Delete
                                        <span v-show="groupMetadata(groupIndex).deleteStatus == 'ok'" class="icon icon-check"></span>
                                        <span v-show="groupMetadata(groupIndex).deleteStatus == 'fail'" class="icon icon-attention"></span>
                                        <LoadingWheel :width="16" v-show="groupMetadata(groupIndex).deleteStatus == 'in-progress'" style="position: relative; top: -2px" />
                                    </a>
                                </div>
                                <div v-show="groupMetadata(groupIndex).saveErrors.length > 0" class="validation-summary-errors">
                                    <ul>
                                        <li v-for="error in groupMetadata(groupIndex).saveErrors">{{ error }}</li>
                                    </ul>
                                </div>
                                <div v-show="groupMetadata(groupIndex).deleteErrors.length > 0" class="validation-summary-errors">
                                    <ul>
                                        <li v-for="error in groupMetadata(groupIndex).deleteErrors">{{ error }}</li>
                                    </ul>
                                </div>
                                <br />
                            </div>
                            <div v-show="groupMetadata(groupIndex).editing">
                                <div class="form-group">
                                    <label :for="'GroupName' + groupIndex">Group Name <span class="required" aria-required="true"></span></label>
                                    <div>
                                        <div class="inline_input">
                                            <input type="text" class="form-control" :id="'GroupName' + groupIndex" v-model="group.displayName" />
                                        </div>
                                    </div>
                                </div>
                                <strong style="font-size: 1.25em; display: block; margin-bottom: 5px">
                                    <img src="./ico_individual.png" height="15" alt="" style="vertical-align: initial" />
                                    Individuals (<span id="modalIndividualsCount">{{ group.individuals.length }}</span
                                    >)
                                </strong>
                                <div class="group_modal_section">
                                    <div class="row hidden-xs">
                                        <div class="col-md-5" style="margin-bottom: 5px">
                                            <strong>Display Name</strong>
                                        </div>
                                        <div class="col-md-3" style="margin-bottom: 5px">
                                            <strong>Email</strong>
                                        </div>
                                        <div class="col-md-3" style="margin-bottom: 5px">
                                            <strong>Phone</strong>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="form-group row" v-for="(individual, individualIndex) in group.individuals">
                                            <div class="col-md-5" style="margin-bottom: 5px">
                                                <div>
                                                    <label class="d-block d-md-none" :for="'displayName_' + groupIndex + '_' + individualIndex">Display Name</label>
                                                    <input type="text" class="form-control" :id="'displayName_' + groupIndex + '_' + individualIndex" v-model="individual.displayName" placeholder="Display Name" />
                                                </div>
                                            </div>
                                            <div class="col-md-3" style="margin-bottom: 5px">
                                                <div>
                                                    <label class="d-block d-md-none" :for="'email_' + groupIndex + '_' + individualIndex">Email</label>
                                                    <input type="text" class="form-control" :id="'email_' + groupIndex + '_' + individualIndex" v-model="individual.email" placeholder="Email" />
                                                </div>
                                            </div>
                                            <div class="col-md-3" style="margin-bottom: 5px">
                                                <div>
                                                    <label class="d-block d-md-none" :for="'phone_' + groupIndex + '_' + individualIndex">Phone</label>
                                                    <input type="text" class="form-control" :id="'phone_' + groupIndex + '_' + individualIndex" v-model="individual.phone" placeholder="Phone (Optional)" />
                                                </div>
                                            </div>
                                            <div class="inline_remove_btn">
                                                <button type="button" class="btn btn btn-outline-secondary" @click="removeIndividual(group, groupIndex, individual, individualIndex)">
                                                    <span class="icon icon-trash"></span>
                                                    <span class="sr-only">Remove</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <button type="button" class="btn btn-outline-secondary" @click="addIndividual(group, groupIndex)">
                                                <span class="plus-sign">+</span>
                                                Individual
                                            </button>
                                        </div>
                                    </div>
                                    <br />
                                </div>
                                <strong style="font-size: 1.25em; display: block; margin-bottom: 5px">
                                    <img src="./ico_group.png" height="15" alt="" style="vertical-align: initial" />
                                    Groups (<span id="modalGroupsCount">{{ group.groups.length }}</span
                                    >)
                                </strong>
                                <div class="group_modal_section">
                                    <div>
                                        <div class="form-group row" v-for="(subgroup, subgroupIndex) in group.groups">
                                            <div class="col-md-11">
                                                <div style="margin-bottom: 5px">
                                                    <!--
                                                    data-bind="value: group, attr: {'aria-label': 'Group ' + ($index() + 1)}, options: $.grep($root.groups(), function(v) { return v != $parent; }), optionsCaption: 'Select one...', optionsText: 'displayName'">
                                                -->
                                                    <select class="form-control" v-model="subgroup.group">
                                                        <option disabled :value="null">Select one...</option>
                                                        <option :value="groupOption" v-for="groupOption in groups.filter(i => i != group)">{{ groupOption.displayName || "&lt;unnamed group&gt;" }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="inline_remove_btn">
                                                <button type="button" class="btn btn btn-outline-secondary" @click="removeSubgroup(group, groupIndex, subgroup, subgroupIndex)">
                                                    <span class="icon icon-trash"></span>
                                                    <span class="sr-only">Remove</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <button type="button" class="btn btn-outline-secondary" @click="addSubgroup(group, groupIndex)">
                                                <span class="plus-sign">+</span>
                                                Group
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="table-responsive" v-show="!groupMetadata(groupIndex).editing">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th style="width: 30px"><span class="sr-only">Individual or Group</span></th>
                                            <th>Display Name</th>
                                            <th>Email</th>
                                            <th>Phone</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="individual in group.individuals">
                                            <td class="text-center"><img src="./ico_individual.png" height="24" alt="" title="Individual" aria-label="Individual" /></td>
                                            <td>{{ individual.displayName }}</td>
                                            <td>{{ individual.email }}</td>
                                            <td>{{ individual.phone }}</td>
                                        </tr>
                                    </tbody>
                                    <tbody>
                                        <tr v-for="subgroup in group.groups">
                                            <td class="text-center"><img src="./ico_group.png" height="24" alt="" title="Group" aria-label="Group" /></td>
                                            <td>
                                                <a data-toggle="collapse" data-parent="#addressBookAccordion" :href="'#group' + groups.indexOf(subgroup.group)" @click.prevent="openGroup(subgroup.group)">{{ (subgroup.group || {}).displayName }}</a>
                                            </td>
                                            <td colspan="2">GROUP</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
//cspell:ignore nocheck
// TODO if we ever use this again, I will care then
//eslint-disable
//@ts-nocheck
import { defineComponent } from "vue";
//import NonIndexStyles from '@/lib/nonIndexStyles.3.vue';
import LoadingWheel from "@/lib/LoadingWheel.3.vue";
import generateGuid from "@/lib/generateGuid";
import { throwIfNonSuccessStatus } from "@/lib/fetchHelpers.3";
import { getXsftHeader } from "@/lib/getXsrfToken.3";
import getData from "../../lib/getData";
import { useMainStore } from "@/mainStore";
function buildGroupMetadata() {
    return {
        unsavedChanges: false,
        open: false,
        editing: false,
        saveStatus: null,
        saveErrors: [],
        deleteStatus: null,
        deleteErrors: [],
    };
}
export default defineComponent({
    data() {
        const data = {
            canEdit: true,
            loading: true,
            groupsMetadata: [],
            groups: [],
        };
        return data;
    },
    components: {
        LoadingWheel,
    },
    async created() {
        const mainStore = useMainStore();
        const addressBookData = await getData(mainStore, "AdminAddressBook", () => mainStore.getUrl("adminAddressBookData"));
        this.canEdit = addressBookData.CanEditAddressBook;
        const groups = addressBookData.ContactGroups.map(vmItem => ({
            id: vmItem.Id,
            groupIds: vmItem.ContactGroupIds || [],
            displayName: vmItem.DisplayName,
            individuals: (vmItem.Contacts || []).map(vmContact => ({
                id: vmContact.Id,
                displayName: vmContact.DisplayName,
                email: vmContact.Email,
                phone: vmContact.Phone,
            })),
        }));
        const groupDict = {};
        groups.forEach(group => {
            groupDict[group.id] = group;
        });
        groups.forEach(group => {
            (group.groups = group.groupIds.map(i => ({ group: groupDict[i] }))), delete group.groupsId;
        });
        this.groups = groups;
        this.groupsMetadata = this.groups.map(buildGroupMetadata);
        window.addEventListener("beforeunload", this.onBeforeUnload);
        this.loading = false;
    },
    destroyed() {
        window.removeEventListener("beforeunload", this.onBeforeUnload);
    },
    computed: {
        groupCount() {
            return this.groups.length;
        },
    },
    asyncComputed: {
        adminUrl() {
            return this.$root.getUrl("admin");
        },
    },
    watch: {
        groups: {
            handler(groups) {
                groups.forEach(group => {
                    const changedIndex = this.groups.indexOf(group);
                    const metadata = this.groupMetadata(changedIndex);
                    metadata.unsavedChanges = true;
                });
            },
            deep: true,
        },
    },
    methods: {
        onBeforeUnload(event) {
            if (this.groupsMetadata.some(i => i.unsavedChanges)) {
                event.preventDefault();
                event.returnValue = "You have unsaved changes";
            }
        },
        groupMetadata(groupIndex) {
            return this.groupsMetadata[groupIndex];
        },
        addIndividual(group, groupIndex) {
            group.individuals.push({ id: generateGuid(), displayName: null, email: null, phone: null });
        },
        removeIndividual(group, groupIndex, individual, individualIndex) {
            group.individuals.splice(individualIndex, 1);
        },
        addSubgroup(group, groupIndex) {
            group.groups.push({ group: null });
        },
        removeSubgroup(group, groupIndex, subgroup, subgroupIndex) {
            group.groups.splice(subgroupIndex, 1);
        },
        addGroup() {
            this.groups.push({
                displayName: null,
                groups: [],
                individuals: [],
            });
            var groupMetadata = buildGroupMetadata();
            groupMetadata.open = true;
            groupMetadata.editing = true;
            this.groupsMetadata.push(groupMetadata);
        },
        async removeGroup(group, groupIndex) {
            const removeData = () => {
                this.groups.splice(groupIndex, 1);
                this.groupsMetadata.splice(groupIndex, 1);
            };
            if (group.id == null) {
                removeData();
                return;
            }
            const metadata = this.groupsMetadata[groupIndex];
            metadata.deleteStatus = "in-progress";
            metadata.deleteErrors = [];
            var deleteUrl = await this.$root.getUrl("adminAddressBookDeleteContactGroup");
            const formData = new FormData(); // TODO json?
            formData.append("Id", group.id);
            try {
                const deleteResponse = await fetch(deleteUrl, {
                    method: "POST",
                    headers: await getXsftHeader(this.$store),
                    credentials: "same-origin",
                    body: formData,
                });
                throwIfNonSuccessStatus(deleteResponse);
                const deleteJson = await deleteResponse.json();
                if (deleteJson.Success) {
                    metadata.deleteStatus = "ok"; // pointless?
                    removeData();
                } else {
                    metadata.deleteStatus = "fail";
                    metadata.deleteErrors = deleteJson.Errors || ["Unknown error occurred"];
                }
            } catch {
                metadata.deleteStatus = "fail";
                metadata.deleteErrors = ["Unknown error occurred"];
            }
        },
        async saveGroup(group, groupIndex) {
            const metadata = this.groupsMetadata[groupIndex];
            metadata.saveStatus = "in-progress";
            metadata.saveErrors = [];
            var saveUrl = await this.$root.getUrl("adminAddressBookSaveContactGroup");
            const formData = new FormData(); // TODO json?
            function appendFormData(key, value) {
                if (value != null) {
                    formData.append(key, value);
                }
            }
            appendFormData("Id", group.id);
            appendFormData("DisplayName", group.displayName);
            group.groups.forEach((subgroup, index) => {
                appendFormData(`ContactGroupIds[${index}]`, (subgroup.group || {}).id);
            });
            group.individuals.forEach((individual, index) => {
                appendFormData(`Contacts[${index}].Id`, individual.id);
                appendFormData(`Contacts[${index}].DisplayName`, individual.displayName);
                appendFormData(`Contacts[${index}].Email`, individual.email);
                appendFormData(`Contacts[${index}].Phone`, individual.phone);
            });
            try {
                const saveResponse = await fetch(saveUrl, {
                    method: "POST",
                    headers: await getXsftHeader(this.$store),
                    credentials: "same-origin",
                    body: formData,
                });
                throwIfNonSuccessStatus(saveResponse);
                const saveJson = await saveResponse.json();
                if (saveJson.Success) {
                    group.id = saveJson.Id;
                    metadata.saveStatus = "ok";
                    metadata.editing = false;
                    metadata.unsavedChanges = false;
                } else {
                    metadata.saveStatus = "fail";
                    metadata.saveErrors = saveJson.Errors || ["Unknown error occurred"];
                }
            } catch {
                metadata.saveStatus = "fail";
                metadata.saveErrors = ["Unknown error occurred"];
            }
        },
        openGroup(group) {
            const selectedIndex = this.groups.indexOf(group);
            this.groupsMetadata.forEach((groupMetadata, groupIndex) => {
                groupMetadata.open = groupIndex == selectedIndex ? !groupMetadata.open : false;
            });
        },
    },
});
</script>
